import React, { act } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  getRoute,
  apiDeleteConFile,
  apiGetConFileGetTipoContenuto,
  apiGetConFileGetAllFiles,
  apiPostAvpPlaylistAddPlaylistContent,
  apiGetConFileGetAllFilesByFolder,
  apiGetAvpNodo,
  apiPostAvpNodoAvatar,
  apiPostAvpNodoLoadingImage,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getValueByQueryString } from "../shared/manager/util";
import Box from "@mui/material/Box";
import GestioneContenutiTree from "./GestioneContenutiTree";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneContenutiPickScreen() {
  const navigate = useNavigate();
  const [tipiContenuto, setTipiContenuto] = useState([]);
  const [currentAction, setCurrentAction] = useState(null);
  const [currentPlaylist, setCurrentPlaylist] = useState(null);
  const [rows, setRows] = useState([]);
  const [searchStringFilter, setSearchStringFilter] = useState("");
  const [tipoContenutoFilter, setTipoContenutoFilter] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [selectedFolder, setSelectedFolder] = useState(null);
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  const breadCrumb = [
    {
      title: selectedLinguaTesto?.GestioneContenutiPickBreadcrumb1,
      link: "/avp",
    },
    {
      title: selectedLinguaTesto?.GestioneContenutiPickBreadcrumb2,
      link: null,
    },
    {
      title: selectedLinguaTesto?.GestioneContenutiPickBreadcrumb3,
      link: null,
    },
    {
      title: selectedLinguaTesto?.GestioneContenutiPickBreadcrumb4,
      link: null,
    },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  useEffect(() => {
    initPage();
  }, [tipoContenutoFilter]);

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 30)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    let action = getValueByQueryString("action");
    setCurrentAction(action);
    let idPlaylist = getValueByQueryString("idplaylist");
    setCurrentPlaylist(idPlaylist);

    setPageTitle(selectedLinguaTesto?.GestioneContenutiPickPageTitle);
    if (action != null) {
      if (action == "addtoplaylist") {
        setPageTitle(
          selectedLinguaTesto?.GestioneContenutiPickTitleAddToPlaylist
        );
      } else if (action == "addtoarc") {
        setPageTitle(selectedLinguaTesto?.GestioneContenutiPickTitleAddToArc);
      } else if (action == "addtonode") {
        setPageTitle(selectedLinguaTesto?.GestioneContenutiPickTitleAddToNode);
      } else if (action == "addloadingtonode") {
        setPageTitle(
          selectedLinguaTesto?.GestioneContenutiPickTitleAddToLoadingNode
        );
      } else if (action == "createagent") {
        setPageTitle(selectedLinguaTesto?.GestioneContenutiPickCreateAgent);
      }
    }

    apiGetConFileGetTipoContenuto(function (response) {
      let tipiList = [];
      let fileList = [];
      if (response != null && response.status >= 200 && response.status < 400) {
        tipiList = response.data;
      }
      let tipoContenutoQuery = getValueByQueryString("tipocontenuto");
      if (tipoContenutoQuery != null && tipoContenutoQuery != "") {
        setTipoContenutoFilter(tipoContenutoQuery);
      }
      apiGetConFileGetAllFiles(
        searchStringFilter,
        tipoContenutoFilter != null && tipoContenutoFilter != ""
          ? tipoContenutoFilter
          : tipoContenutoQuery != null
          ? tipoContenutoQuery
          : "",
        function (filesResp) {
          if (
            filesResp != null &&
            filesResp.status >= 200 &&
            filesResp.status < 400
          ) {
            fileList = filesResp.data;
          }

          setTipiContenuto(tipiList);
          setRows(fileList);
          console.log("tipiList", tipiList);
          console.log("fileList", fileList);
        }
      );
    });
  }

  function getTipoFileDesc(idTipoFile) {
    let desc = "";
    if (tipiContenuto != null && tipiContenuto.length > 0) {
      for (let i = 0; i < tipiContenuto.length; i++) {
        if (tipiContenuto[i].idTipoFile == idTipoFile) {
          desc = tipiContenuto[i].descTipoFile;
          break;
        }
      }
    }
    return desc;
  }

  const columns = [
    {
      field: "descFile",
      headerName: selectedLinguaTesto?.GestioneContenutiPickColumnName,
      flex: 2,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "tipoContenuto",
      headerName: selectedLinguaTesto?.GestioneContenutiPickColumnType,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        let desc = getTipoFileDesc(params.row.tipoContenuto);

        return desc;
      },
    },
    {
      field: "pathFile",
      headerName: selectedLinguaTesto?.GestioneContenutiPickColumnFile,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "folderPath",
      headerName: selectedLinguaTesto?.GestioneContenutiPickColumnFolder,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      width: 200,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          const action = event.target.dataset.action;
          if (action == "delete") {
            handleDelete(params.row.idFile);
          } else if (action == "edit") {
            handleEdit(params.row.idFile);
          } else if (action == "add") {
            handleAdd(params.row.idFile, params.row.descFile);
          } else if (action == "preview") {
            handlePreview(params.row.idFile);
          }
        };

        let showUp = params.row.ordine > 1;
        let showDown = params.row.ordine == 1;

        return (
          <div className="tableActionSmallButton">
            <img
              data-action={selectedLinguaTesto?.GestioneContenutiPickImgPreview}
              src="/images/preview_btn.svg"
              title="anteprima"
              onClick={onClick}
            />
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiPickImgEdit}
              onClick={onClick}
            />
            <img
              data-action="delete"
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiPickImgDelete}
              onClick={onClick}
            />
            <img
              data-action="add"
              src="/images/add_node_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiPickImgAdd}
              onClick={onClick}
              style={{ display: currentAction != null ? "inline" : "none" }}
            />
          </div>
        );
      },
    },
  ];

  function findFileInRows(idFile) {
    if (rows != null && rows.length > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].idFile == idFile) {
          return rows[i];
        }
      }
    }
    return null;
  }

  function handleNew() {
    const dest = "/contenuti/file?action=new";
    navigate(dest);
  }

  function handleEdit(idFile) {
    const dest = "/contenuti/file?action=edit&idfile=" + idFile;
    navigate(dest);
  }

  function handlePreview(idFile) {
    let file = findFileInRows(idFile);
    if (file != null && file.urlFile != null) {
      window.open(file.urlFile, "_blank");
    }
  }

  function handleAdd(idFile, descFile) {
    let action = getValueByQueryString("action");
    if (action != null) {
      if (action == "addtoplaylist") {
        handleAddToPlaylist(idFile);
      } else if (action == "addtoavatar") {
        handleAddToAvatar(idFile);
      } else if (action == "addtonode") {
        handleAddToNode(idFile);
      } else if (action == "addloadingtonode") {
        handleAddLoadingImageToNode(idFile);
      } else if (action == "createagent") {
        handleCreateNewAgent(idFile, descFile);
      }
    }
  }

  function handleCreateNewAgent(idFile, descFile) {
    let agentId = getValueByQueryString("agentId");
    let agentForm = localStorage.getItem("agnetForm");
    agentForm = JSON.parse(agentForm);
    agentForm.idFile = idFile + "";
    agentForm.descFile = descFile;
    localStorage.setItem("agnetForm", JSON.stringify(agentForm));
    if (agentId != null && agentId != "" && agentId != "null") {
      navigate("/contenuti/agent?id=" + agentId);
    } else {
      navigate("/contenuti/agent");
    }
  }
  function handleAddToPlaylist(idFile) {
    let idPlaylist = getValueByQueryString("idplaylist");
    let playlistFile = {
      idPlaylist: idPlaylist,
      idFile: idFile,
      durataVisualizzazione: 0,
      ordine: 0,
    };

    apiPostAvpPlaylistAddPlaylistContent(playlistFile, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setAlertSuccessOpen(true);
          setAlertErrorOpen(false);
          let idAvp = getValueByQueryString("idavp");
          let idNodo = getValueByQueryString("idnodo");
          let idLingua = getValueByQueryString("lingua");
          const dest =
            "/avp/grafo/" +
            idAvp +
            "?idnodo=" +
            idNodo +
            "&idlingua" +
            idLingua;
          navigate(dest);
        } else {
          setAlertSuccessOpen(false);
          setAlertErrorOpen(true);
        }
      }
    });
  }

  function handleAddToAvatar(idFile) {
    let folder = getValueByQueryString("folder");
    navigate(
      "/contenuti/avatar?action=new&folder=" + folder + "&idfile=" + idFile
    );
  }

  function handleAddToNode(idFile) {
    let idAvp = getValueByQueryString("avp");
    let idNodo = getValueByQueryString("node");
    let lingua = getValueByQueryString("lingua");
    let tipocontenuto = getValueByQueryString("tipocontenuto");
    apiGetAvpNodo(idNodo, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        const tipoAvatar = tipocontenuto == 5 ? 1 : 2;
        const avatar = {
          idNodo: idNodo,
          idLingua: lingua,
          idFile: idFile,
          tipoAvatar: tipoAvatar,
          formato: "",
          speechText: "",
        };
        apiPostAvpNodoAvatar(avatar, function (avatarResponse) {
          if (
            avatarResponse != null &&
            avatarResponse.status >= 200 &&
            avatarResponse.status < 400
          ) {
            let idLingua = getValueByQueryString("lingua");
            navigate(
              "/avp/grafo/" +
                idAvp +
                "?idnodo=" +
                idNodo +
                "&idlingua" +
                idLingua
            );
          } else {
            setAlertSuccessOpen(false);
            setAlertErrorOpen(true);
          }
        });
      }
    });
  }
  function handleAddLoadingImageToNode(idFile) {
    let idAvp = getValueByQueryString("avp");
    let idNodo = getValueByQueryString("node");
    let lingua = getValueByQueryString("lingua");
    apiGetAvpNodo(idNodo, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        const immagineLoading = {
          idNodo: idNodo,
          idLingua: lingua,
          idFile: idFile,
          formato: "",
        };
        apiPostAvpNodoLoadingImage(immagineLoading, function (avatarResponse) {
          if (
            avatarResponse != null &&
            avatarResponse.status >= 200 &&
            avatarResponse.status < 400
          ) {
            let idLingua = getValueByQueryString("lingua");
            navigate(
              "/avp/grafo/" +
                idAvp +
                "?idnodo=" +
                idNodo +
                "&idlingua" +
                idLingua
            );
          } else {
            setAlertSuccessOpen(false);
            setAlertErrorOpen(true);
          }
        });
      }
    });
  }

  function handleDelete(idFile) {
    setIdToDelete(idFile);
    setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);
    apiDeleteConFile(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function onTipoContenutoFilterChange(event) {
    let value = event.target.value;
    setTipoContenutoFilter(value);
  }

  function onSearchStringFilterChange(event) {
    let value = event.target.value;
    setSearchStringFilter(value);
  }

  function handleSearch() {
    initPage();
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleSearch();
    }
  }

  function folderActionCallback(action, folderId) {
    console.log("folderActionCallback=" + action + "  folder=" + folderId);
    if (action != null) {
      if (action == "select") {
        onFolderSelect(folderId);
      }
    }
  }

  function onFolderSelect(idFolder) {
    setSelectedFolder(idFolder);
    apiGetConFileGetAllFilesByFolder(
      idFolder,
      0,
      searchStringFilter,
      function (filesResp) {
        if (
          filesResp != null &&
          filesResp.status >= 200 &&
          filesResp.status < 400
        ) {
          let fileList = filesResp.data;
          setRows(fileList);
        }
      }
    );
  }

  return (
    <div id="avp-gestionecontenuti-screen">
      <AvpHeader selectedMenuId={"contenuti"} />
      <BreadCrumb
        items={breadCrumb}
        helpLink={"help.html#selezionecontenuti"}
      />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneContenutiPickAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneContenutiPickAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-title">{pageTitle}</div>
        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;{" "}
              {selectedLinguaTesto?.GestioneContenutiPickSubtitle}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div className="avp-cms-screen-toolbar-add" onClick={handleNew}>
              <button>
                {selectedLinguaTesto?.GestioneContenutiPickButtonNew}
              </button>
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-tipofile">
                {selectedLinguaTesto?.GestioneContenutiPickContentType}
              </label>
              <br />
              <select
                id="avp-form-tipofile"
                value={tipoContenutoFilter}
                onChange={onTipoContenutoFilterChange}
              >
                <option key={-1} value="">
                  {selectedLinguaTesto?.GestioneContenutiPickOptionAll}
                </option>
                {tipiContenuto != null && tipiContenuto.length > 0 ? (
                  tipiContenuto.map((item, i) => {
                    return (
                      <option key={item.idTipoFile} value={item.idTipoFile}>
                        {item.descTipoFile}
                      </option>
                    );
                  })
                ) : (
                  <option></option>
                )}
              </select>
            </div>

            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pathfile">
                {selectedLinguaTesto?.GestioneContenutiPickSearchText}
              </label>
              <br />
              <input
                id="avp-form-pathfile"
                type="text"
                value={searchStringFilter}
                onChange={onSearchStringFilterChange}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="avp-cms-screen-content-column">
              <button
                onClick={handleSearch}
                style={{
                  "border-radius": "10px",
                  height: "34px",
                  "margin-top": "20px",
                }}
              >
                CERCA
              </button>
            </div>
          </div>

          <div id="avp-cms-contenuti-screen-box" className="clearfix">
            <div
              id="avp-cms-contenuti-screen-box-tree"
              style={{ position: "relative", float: "left", width: "30%" }}
            >
              <GestioneContenutiTree
                actionCallback={folderActionCallback}
                showToolbar={false}
                initialFolder={selectedFolder != null ? selectedFolder : 1}
                showInitialFolder={true}
                autoExpandToSelection={false}
                showBin={true}
              />
            </div>
            <div
              id="avp-cms-contenuti-screen-box-list"
              style={{ position: "relative", float: "left", width: "70%" }}
            >
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  disableColumnMenu
                  getRowId={(row) => row.idFile}
                  rows={rows}
                  columns={columns}
                  getRowClassName={(params) => "tableRow"}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[10, 20, 30, 40]}
                  disableRowSelectionOnClick
                  autoheight
                />
              </Box>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedLinguaTesto?.GestioneContenutiPickDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneContenutiPickDialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.GestioneContenutiPickDialogUndo}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneContenutiPickDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
